import { relativesAddressNameFields } from 'constants/enums/people';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { hasYesOrNo } from 'models/validate';
import { RelationshipsCohabitantsModel } from './types';
import { relationshipsCohabitantItemValidator } from './validators/item';

const relationshipsCohabitantsValidator: ValidateJSModel<RelationshipsCohabitantsModel> = {
  HasCohabitant: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },
  Comments: {},
  SummaryComments: {},
  CohabitantList: (value, attributes, attributeName, options) => {
    let additionalValidation = {};
    const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, relativesAddressNameFields);

    if (errors.length > 0) {
      additionalValidation = {
        requireTrue: { // force error message; value will never be true
          message: 'relationships.relatives.error.duplicateListItems',
        }
      };
    }

    if (attributes?.HasCohabitant && attributes?.HasCohabitant.value === 'Yes') {
      return {
        ...additionalValidation,
        presence: true,
        accordion: { validator: relationshipsCohabitantItemValidator },
      };
    }

    return {};
  },
};

export default relationshipsCohabitantsValidator;
